import type { LinkMomentsResult, TicketMomentsView } from '@live-stream/shared'
import type { HttpClient } from '../http.js'

const enc = encodeURIComponent

/**
 * Where tickets were talked about in a past meeting, and the links to those moments in Jira (E5). Its own
 * small client: it reads a meeting's transcript and its team's board, and has nothing to do with recordings,
 * videos or any editor. A moment is a place in the meeting, opened by the meeting page's `?t=` link.
 */
export class TicketMoments {
  constructor(private readonly http: HttpClient) {}

  /**
   * The moments of a meeting this person may see: for whoever leads the team, every ticket's; for anyone else
   * linked to Jira, those of their own tickets. Fails (404) for a meeting that was not a Jira team's.
   */
  async get(sessionId: string): Promise<TicketMomentsView> {
    return (await this.http.get<{ moments: TicketMomentsView }>(`/ticket-moments/${enc(sessionId)}`)).moments
  }

  /** Put a link to the moment each of these tickets was first talked about in a comment on it in Jira (who leads the team). */
  link(sessionId: string, keys: string[]): Promise<LinkMomentsResult> {
    return this.http.post<LinkMomentsResult>(`/ticket-moments/${enc(sessionId)}/links`, { keys })
  }

  /** Take a link back out of Jira (its comment is deleted). */
  async unlink(sessionId: string, key: string): Promise<void> {
    await this.http.delete(`/ticket-moments/${enc(sessionId)}/links/${enc(key)}`)
  }
}
